<mat-card appearance="outlined" class="additional-service">
  <div>
    <mat-card-header>
      <mat-card-title>
        <h5 class="font-size-headline4 text-dark">{{ serviceAddon.title }}</h5>
        <div class="additional-service__icon">
          <div
            class="additional-service__icon--circle"
            [ngClass]="{ green: cardColor === 'green', blue: cardColor === 'blue' }"
          >
            <img src="{{ serviceAddon.icon }}" alt="service icon" />
          </div>
          <p class="text-dark">{{ serviceAddon.displayName }}</p>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ul>
        @for (homeFeature of serviceAddon.homeFeatures; track homeFeature) {
          <li [ngClass]="{ green: cardColor === 'green', blue: cardColor === 'blue' }">{{ homeFeature }}</li>
        }
      </ul>
    </mat-card-content>
  </div>
  <mat-card-actions>
    <button
      mat-button
      color="primary"
      [disabled]="disableButton()"
      [ngClass]="{
        green: cardColor === 'green' && !disableButton(),
        blue: cardColor === 'blue' && !disableButton(),
        disabled: disableButton(),
      }"
      (click)="onAddService()"
      style="height: 52px"
    >
      {{ buttonText }}
    </button>
  </mat-card-actions>
</mat-card>
